import { styled, Typography } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const StyledListItemCaption = styled(Typography)(({ theme }) => ({
  ...theme.typography.body_m1,
  color: theme.palette.neutralGrey[45],
}));
